export const customStyles8 = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: '176px',
        borderRadius: '14px',
        backgroundColor: '#FFF',
        boxShadow: '0px 30px 100px 0px rgba(0, 0, 0, 0.20)',
        padding: '0px',
        cursor: 'pointer',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
};
